/**
 * Models an admin account object
 */

import Brace from "backbone.brace";

import environment from "../../common/environment";

const Model = Brace.Model.extend({
  urlRoot: environment.getEndpoint("admin.accounts"),

  namedAttributes: {
    id: Number,
    ciamUserId: String,
    firstName: String,
    lastName: String,
    username: String,
    roles: Object,
    enabled: Boolean,
    visible: Boolean,
  },

  defaults: {
    id: null,
    ciamUserId: null,
    firstName: null,
    lastName: null,
    username: null,
    roles: null,
    enabled: false,
    visible: false,
  },
});

export { Model as default };
